<template>
  <pricing v-if="!isFetching" :onCreatePayment="createPayment" :profileTariff="tariff" :tariffs="tariffs"
    :products="products" :balance="balance" :is-filled="isFilled" :is-identified="isIdentified" />
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { requestBalanceFund } from "../../../services/api/finance";
import Pricing from "./Pricing.vue";

export default {
  name: "pricing-container",
  components: {
    Pricing
  },
  data() {
    return {
      isFetching: false
    };
  },
  methods: {
    ...mapActions(["error"]),
    ...mapActions("paymentHistory", ["addRecord"]),
    ...mapActions("tariff", ["fetchTariffs"]),
    ...mapActions('profile', ['fetchProfile']),

    createPayment(values) {
      return requestBalanceFund(values)
        .then(res => {
          this.addRecord(res.data);

          if (res.data.link) {
            window.location.href = res.data.link;
          } else {
            window.open(`/api/v1/finance/fundHistory/pdf?id=${res.data.id}`, '_blank');
          }

          return res;
        })
        .catch(res => {
          this.error(res);

          return Promise.reject(res);
        });
    }
  },
  created() {
    if (!this.isFetching) {
      this.isFetching = true;
      this.fetchTariffs()
        .then(res => {
          this.fetchProfile()
            .then((res) => {
              this.isFetching = false;
            })
            .catch((res) => {
              this.isFetching = false;
            });
        })
        .catch(res => {
          this.isFetching = false;
        });
    }
  },
  data() {
    return {
      isFetching: false
    };
  },
  computed: {
    ...mapState("tariff", ["tariffs"]),
    ...mapState('profileTariff', ['tariff']),
    ...mapGetters("tariff", {
      tariffsIsFetched: "isFetched"
    }),
    ...mapGetters('request', ['products']),
    ...mapGetters('profile', ['isFilled', 'isIdentified', 'balance'])
  }
};
</script>



// WEBPACK FOOTER //
// PricingContainer.vue?61a08777